import { useCallback, useEffect } from 'react';
import type { Map as MapTypes } from 'mapbox-gl';
import type { PopupState } from '../../../store/map/types';

import { HOTELS_LAYERS, CITY_ZOOM } from '../constants';
import {
  adjustMapPosition,
  getCoordinates,
  getMapFeatureProperties,
  zoomToCity,
} from '../utils';

interface useHotelsLayerProps {
  mapbox?: MapTypes;
  isMobile: boolean;
  setPopupDataHandler: (popupData: PopupState) => void;
  getImages: (hotelId: number) => void;
}

/**
 * Работа с попапом на карте
 */
export const usePopup = (props: useHotelsLayerProps): void => {
  const { mapbox, isMobile, setPopupDataHandler, getImages } = props;

  const enter = useCallback(
    (e) => {
      if (mapbox && mapbox.getZoom() < CITY_ZOOM) return;

      const properties = getMapFeatureProperties(e);
      const coordinates = getCoordinates(e);

      const data = {
        ...properties,
        coordinates,
      };
      if (isMobile) {
        getImages(data.id);
      }

      setPopupDataHandler(data);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [mapbox, setPopupDataHandler],
  );

  useEffect(() => {
    if (!mapbox) return;

    HOTELS_LAYERS.forEach((layer) => {
      mapbox.on('click', layer, (e) => {
        zoomToCity(mapbox, e);

        if (mapbox.getZoom() >= CITY_ZOOM) {
          const coordinates = getCoordinates(e);
          adjustMapPosition(mapbox, coordinates, { offset: [0, -150] });

          enter(e);
        }
      });

      if (!isMobile) {
        // меняем вид курсора, чтобы показать, что регионы кликабельные
        mapbox.on('mouseenter', layer, () => {
          mapbox.getCanvas().style.cursor = 'pointer';
        });
        mapbox.on('mouseleave', layer, () => {
          mapbox.getCanvas().style.cursor = '';
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapbox]);
};
